<script lang="ts">
	//Design system components
	import { IconButton, Input } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	//Helpers
	import {
		getErrorOrInfoMessageForMinAndMaxUnit,
		valueOutOfDecimalRange,
	} from 'src/helpers/utilities';
	import { addNumberStep } from 'src/helpers/number_input_helpers';

	export let value: number,
		min: number,
		max: number,
		unit: string,
		step: number = 1,
		icon = 'fas fa-calculator',
		minDecimalDigits: number = null;

	type MinMaxInfo = { error: string; info: string };

	let minMaxInfo: MinMaxInfo = { error: '', info: '' };

	/**
	 * Handle user input change
	 * @param {string} val
	 */
	const handleChange = (val: number) => {
		value = Number(val);
	};

	const valueOutOfRange = (value: number | string): MinMaxInfo => {
		const minMaxInfo = getErrorOrInfoMessageForMinAndMaxUnit(
			value === '' ? NaN : Number(value),
			min,
			max,
			unit,
		);
		if (!minMaxInfo.error && minDecimalDigits !== null) {
			const decimalError = valueOutOfDecimalRange(value.toString(), minDecimalDigits);
			if (decimalError) minMaxInfo.error = decimalError;
		}
		return minMaxInfo;
	};

	$: minMaxInfo = valueOutOfRange(value);
</script>

<div class="d-flex mt-s">
	<IconButton
		aria-label={$format('button_decrease', { default: 'Decrease' })}
		icon="fas fa-minus"
		on:click={() => {
			handleChange(addNumberStep(value, -step));
		}}
		disabled={value <= min}
	/>
	<Input
		aria-label={$format('input_set_value', { default: 'Set value' })}
		class="width-md-l width-sm-full ml-s mr-s"
		size="m"
		{icon}
		type="number"
		value={value?.toString() || ''}
		info={minMaxInfo.info}
		error={minMaxInfo.error}
		on:input={(e) => {
			handleChange(e.target['value']);
		}}
		id="input-6ze8us0"
	/>
	<IconButton
		aria-label={$format('button_increase', { default: 'Increase' })}
		icon="fas fa-plus"
		on:click={() => {
			handleChange(addNumberStep(value, step));
		}}
		disabled={value >= max}
	/>
</div>
